export default "__VITE_ASSET__DTDVLEEX__"